import { tv } from "@fanka/tailwind-variants";

export const REQUIRED_CLASS_NAME = tv({
  base: "whitespace-nowrap",
  variants: {
    rectangle: {
      true: "text-ui10 px-[4px] py-[2px] bg-ui-required text-base-0 rounded-sm",
      false: "text-ui12 text-functional-danger before:content-['※']",
    },
  },
});
